export const SHOW_SPEC_COURSE_BANNER_TEAM_LEVEL = +process.env.SHOW_SPEC_COURSE_BANNER_TEAM_LEVEL!! || 5;
